import { createTheme, Modal } from '@mantine/core';

export const theme = createTheme({
  /** Your theme customization here */
  primaryColor: 'blue',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: '600',
  },
  defaultRadius: 'md',
  colors: {
    // You can customize colors here if needed
  },
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '88em',
  },
  components: {
    Modal: Modal.extend({
      styles: {
        header: {
          backgroundColor: 'var(--mantine-color-blue-4)',
          color: 'white',
        },
        title: {
          color: 'white',
          fontWeight: 600,
        },
        close: {
          color: 'white',
          '&:hover': {
            backgroundColor: 'var(--mantine-color-blue-6)',
            color: 'white',
          },
        },
      },
    }),
  },
});
